import { useTranslation } from 'react-i18next'

import headerBanner from '@/assets/dashboard/headerpanel.png'
import { useProductos } from '@/features/productos/hooks/useProductos'
import { formatRate } from '@/shared/utils/formatters'

export function ProductosPage() {
  const { t, i18n } = useTranslation('productos')
  const { productos, loading, error } = useProductos(i18n.language)

  const pageHeader = (
    <>
      <img
        src={headerBanner}
        alt={t('bannerAlt')}
        className="mx-6 mt-4 block max-h-[5.5rem] w-[calc(100%-3rem)] rounded-sm object-cover max-md:mx-4 max-md:w-[calc(100%-2rem)]"
      />
      <div className="px-6 py-4 max-md:px-4">
        <h1 className="mb-6 text-[1.375rem] font-bold text-text-primary">
          {t('title')}
        </h1>
      </div>
    </>
  )

  if (loading) {
    return (
      <>
        {pageHeader}
        <div className="px-6 pt-0 max-md:px-4">
          <div className="grid gap-5 [grid-template-columns:repeat(auto-fit,minmax(22rem,30rem))] max-w-[96rem] max-lg:grid-cols-[repeat(auto-fit,minmax(20rem,28rem))] max-md:grid-cols-1 max-md:max-w-full">
            {[1, 2, 3].map((n) => (
              <div key={n} className="h-56 rounded-md" />
            ))}
          </div>
        </div>
      </>
    )
  }

  if (error) {
    return (
      <>
        {pageHeader}
        <div className="px-6 pt-0 max-md:px-4">
          <div className="flex flex-col items-center justify-center gap-4 px-8 py-16 text-center">
            <p className="m-0 text-body-3 text-text-muted">
              {error}
            </p>
          </div>
        </div>
      </>
    )
  }

  if (productos.length === 0) {
    return (
      <>
        {pageHeader}
        <div className="px-6 pt-0 max-md:px-4">
          <div className="flex flex-col items-center justify-center gap-4 px-8 py-16 text-center">
            <p className="m-0 text-[1.125rem] font-semibold text-text-primary">
              {t('emptyTitle')}
            </p>
            <p className="m-0 text-body-3 text-text-muted">
              {t('emptyDesc')}
            </p>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <img
        src={headerBanner}
        alt={t('bannerAlt')}
        className="mx-6 mt-4 block max-h-[5.5rem] w-[calc(100%-3rem)] rounded-sm object-cover max-md:mx-4 max-md:w-[calc(100%-2rem)]"
      />

      <div className="px-6 py-4 max-md:px-4">
        <h1 className="mb-6 text-[1.375rem] font-bold text-text-primary">
          {t('title')}
        </h1>

        <div className="grid gap-5 [grid-template-columns:repeat(auto-fit,minmax(22rem,30rem))] max-w-[96rem] max-lg:grid-cols-[repeat(auto-fit,minmax(20rem,28rem))] max-md:grid-cols-1 max-md:max-w-full">
          {productos.map((grupo) => (
            <article
              key={grupo.id}
              className="flex flex-col gap-4 overflow-hidden rounded-md bg-surface-card p-0 shadow-card [transition:box-shadow_0.2s_ease,transform_0.2s_ease] hover:-translate-y-0.5 hover:shadow-[0_4px_20px_rgba(0,102,170,0.12)]"
            >
              <div className="flex flex-1 flex-col gap-4 bg-[linear-gradient(135deg,#3a8fd4_0%,#1a5fa8_100%)] px-5 py-5 text-white">
                <span className="text-body-2 font-bold text-white">
                  {grupo.nombre}
                </span>

                <div className="mt-3 flex items-end justify-between gap-4">
                  <div className="flex flex-col gap-0.5">
                    <p className="m-0 text-[1.5rem] font-extrabold leading-[1.1] text-white">
                      {formatRate(grupo.tasaAnualMaxima)}%
                    </p>
                    <span className="text-[0.6875rem] font-normal text-white">
                      {t('rateLabel')}
                    </span>
                  </div>

                  <div className="flex shrink-0 flex-col items-end gap-0.5 text-right">
                    <span className="text-[0.75rem] font-normal text-white/80">
                      {t('permanenciaLabel')}
                    </span>
                    <span className="text-[1.125rem] font-bold text-white">
                      {t('permanenciaValue', { days: grupo.diasMinPermanencia })}
                    </span>
                  </div>
                </div>

                {grupo.descripcion && (
                  <p className="mt-4 m-0 text-body-3 leading-[1.6] text-white">
                    {grupo.descripcion}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </>
  )
}
